import { FC } from 'react'

import { Rate, RateProps } from 'antd'

import { getStarIcon } from './helper'

export type RateStarsProps = RateProps & {
  disabled?: boolean
  unchangeable?: boolean
}

const DEFAULT_COUNT = 5

export const RateStars: FC<RateStarsProps> = ({
  disabled,
  value = 0,
  count = DEFAULT_COUNT,
  unchangeable,
  ...rest
}) => (
  <Rate
    allowClear={false}
    disabled={disabled || unchangeable}
    value={value}
    count={count}
    character={({ index }) => getStarIcon(index ?? 0, value)}
    {...rest}
  />
)
